import { render, staticRenderFns } from "./ApplyTickerSettings.vue?vue&type=template&id=fed7d0a2&scoped=true"
import script from "./ApplyTickerSettings.vue?vue&type=script&lang=js"
export * from "./ApplyTickerSettings.vue?vue&type=script&lang=js"
import style0 from "./ApplyTickerSettings.vue?vue&type=style&index=0&id=fed7d0a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed7d0a2",
  null
  
)

export default component.exports